function isAllowedKey(event: KeyboardEvent, allowedChars: string[] = []) {
  const controlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab']
  return controlKeys.includes(event.key) || /^[0-9]$/.test(event.key) || allowedChars.includes(event.key)
}

export default {
  mounted(el: HTMLElement, binding: { value?: string | string[] }) {
    let input: HTMLInputElement
    if (el instanceof HTMLInputElement) input = el
    else input = el.querySelector('.q-field__native') as HTMLInputElement
    if (!input) return

    const allowedChars = Array.isArray(binding.value)
      ? binding.value
      : typeof binding.value === 'string'
        ? [binding.value]
        : []

    input.addEventListener('keydown', (event: KeyboardEvent) => {
      if (!isAllowedKey(event, allowedChars)) event.preventDefault()
    })
  },
}
